import { Link } from 'react-router-dom';

const footerLinks = {
  资源分类: [
    { label: '汉化版', path: '/category/hanhua' },
    { label: '日文原版', path: '/category/riwen' },
    { label: '补丁包', path: '/category/buding' },
    { label: '攻略合集', path: '/category/gonglve' },
    { label: '全年龄', path: '/category/quanlingyu' },
  ],
  热门推荐: [
    { label: '新作速递', path: '/category/xinyou' },
    { label: '重制版', path: '/category/remake' },
    { label: '同人佳作', path: '/category/tongren' },
    { label: 'CLANNAD攻略', path: '/article/1' },
    { label: '汉化补丁教程', path: '/article/4' },
  ],
  关于本站: [
    { label: '关于我们', path: '/about' },
    { label: '常见问题', path: '/#faq' },
    { label: '联系方式', path: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-gamepad-line text-2xl text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                Galgame资源站
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed">
              最全PC版Galgame下载平台，汇聚海量汉化版、日文原版Galgame游戏资源，涵盖补丁包及攻略合集，支持Windows系统免费下载。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-base font-semibold mb-4 text-background-50">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/60">
            &copy; {new Date().getFullYear()} Galgame资源站PC. All rights reserved.
          </p>
          <p className="text-sm text-background-50/60">
            Galgame资源网站PC — 最全PC版Galgame下载平台
          </p>
        </div>
      </div>
    </footer>
  );
}